import * as React from 'react';

function Biathlon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.783 21C4.403 21 3 20.284 3 18.695a.768.768 0 011.53-.089l.005.09c0 .406.475.694 1.72.755l.343.011h6.689l-1.34-3.918-.026-.096a.767.767 0 01.3-.773l2.706-1.977-2.357-2.727-1.127 1.646-.057.073a.766.766 0 01-.576.26H9.293l-1.709 6.93-1.49-.37 1.618-6.56h-.106l-.09-.005a.768.768 0 01-.677-.762l.005-.09a.768.768 0 01.762-.677h2.8l1.46-2.134.061-.078a.768.768 0 011.153.01l3.553 4.113.057.075a.767.767 0 01-.186 1.046l-2.92 2.133 1.327 3.883h4.979a.768.768 0 01.09 1.53l-.09.005H6.783zm5.6-17.809l.069.068 6.045 6.825a.768.768 0 01-1.08 1.086l-.069-.068-6.046-6.825a.768.768 0 011.081-1.086zm-2.09 1.686a1.92 1.92 0 110 3.84 1.92 1.92 0 010-3.84z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Biathlon;
